//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Building from './_building'
export default {
    components: {
        Building
    },
    props: {
        selected_index: Number,
        items: Array,
        category: String,
        classname: String,
        loading: Boolean
    },
    watch: {
        selected_index (index) {
            const item = document.getElementById(`item_${index}`)
            console.log('scrollIntoView', index)
            // item.scrollIntoView()
        }
    },
    methods: {
        onSelect (i) {
            this.$emit('select', i)
        }
    }
}
